import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["fill"];
import React from 'react';
var SVG_PATHS = [{
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9ZM2.01759 8.5H15.9824C15.7261 4.86736 12.6979 2 9.00001 2C5.30213 2 2.27396 4.86736 2.01759 8.5Z'
}];
export var DEFAULT_FILL_NEAR_MASTERY = '#FBB918';
export var NearMasteryIcon = function NearMasteryIcon(_ref) {
  var _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? DEFAULT_FILL_NEAR_MASTERY : _ref$fill,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    id: "near-mastery",
    width: "18",
    height: "18",
    viewBox: "-1 -1 20 20",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Near Mastery"
  }, props), SVG_PATHS.map(function (pathProps, index) {
    return /*#__PURE__*/React.createElement("path", Object.assign({
      key: index
    }, pathProps));
  }));
};
export var nearMasteryIconSvgPaths = SVG_PATHS.map(function (p) {
  return "<path fill-rule=\"".concat(p.fillRule, "\" d=\"").concat(p.d, "\"/>");
}).join('');